import { ReactNode } from "react";
import styled from "styled-components";
import { getTheme } from "Theme";
const theme = getTheme();

const Main = styled.button<{
  color?: string;
  height?: string;
  width?: string;
  margin?: string;
}>`
  background-color: ${(props) => props.color || theme.BUTTON_COLOR};
  color: ${theme.BUTTON_TEXT};
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue",
    Arial, sans-serif;
  border: none;
  border-radius: 5px;
  padding: 6px 10px;
  cursor: pointer;
  font-weight: 600;
  height: ${(props) => props.height || "30px"};
  width: ${(props) => props.width || "fit-content"};
  margin: ${(props) => props.margin};
  :hover {
    opacity: 0.85;
  }
`;

interface Props {
  color?: string;
  height?: string;
  width?: string;
  margin?: string;
  children: ReactNode;
  onClick: () => void;
}
const Button = (props: Props) => {
  return <Main {...props}>{props.children}</Main>;
};

export default Button;
